<template>
  <PropertyDetailsCard>
    <template #title>Renter requirements</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <RenterRequirementsInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added renter requirements yet"
      subtitle="Specify renter qualifications to streamline your search"
      button-text="Add renter requirements"
      @button-clicked="showModal"
    />
    <RenterRequirementsModal ref="renterRequirementsModal" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  RenterRequirementsInfo,
} from '@tallo/property';

import RenterRequirementsModal from './renter-requirements-modal.vue';

const renterRequirementsModal = ref<InstanceType<typeof RenterRequirementsModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.renterRequirements));

function showModal() {
  renterRequirementsModal.value?.modalRef?.show();
}
</script>
